<template>
  <div class="container">
    <h4 class="cardD">Capítulos especiales</h4>

    <div class="row mt-3">
      <div class="col-6" v-if="constitutiva.tipo_societario!='S de RL'">
        <label for="check_reglas_control">Reglas de control corporativo</label>
        <b-form-checkbox
          id="check_reglas_control"
          v-model="constitutiva.reglas_control"
          :disabled="constitutiva.disabled"
        >
        </b-form-checkbox>
        <label
          class="mt-2 leyenda blue-text-important"
          v-if="constitutiva.reglas_control"
          :disabled="constitutiva.disabled"
        >
          La cotización básica no incluye esta opción.
        </label>
      </div>
      <div class="col-6">
        <label for="check_reglas_asambleas">Reglas para asambleas telemáticas</label>
        <b-form-checkbox
          id="check_reglas_asambleas"
          v-model="constitutiva.reglas_asambleas"
          :disabled="constitutiva.disabled"
        >
        </b-form-checkbox>
        <label class="mt-2 leyenda blue-text-important" v-if="constitutiva.reglas_asambleas">
          La cotización básica no incluye esta opción.
        </label>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-6">
        <label for="check_exclusion_accionistas">Exclusión de accionistas</label>

        <div v-if="constitutiva.roleStaff">
          <b-form-checkbox
            id="check_exclusion_accionistas"
            v-model="constitutiva.exclusion_accionistas"
            :disabled="constitutiva.disabledEspeciales"
          >
          </b-form-checkbox>
        </div>
        <div v-else>
          <b-form-checkbox
            id="check_exclusion_accionistas"
            v-model="constitutiva.exclusion_accionistas"
            :disabled="constitutiva.disabled"
          >
          </b-form-checkbox>
        </div>

        <label class="mt-2 leyenda blue-text-important" v-if="constitutiva.exclusion_accionistas">
          La cotización básica no incluye esta opción.
        </label>
      </div>
    </div>

    <div class="mt-4">
      <div class="">
        <b-button
          type="submit"
          class="btn-fill orange-btn bottom2"
          size="m"
          :disabled="constitutiva.disabled"
          >Continuar</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CapitulosEspeciales",

  props: {
    constitutiva: { type: Object }
  },

  data() {
    return {
      form: {
        reglas_control: null,
        reglas_asambleas: null
      }
    };
  }
};
</script>
